import Modal from './modal.vue';
import { createVNode, render } from 'vue';

export default {
  install(Vue) {
    let modalData = {};
    let vNode;
    window.modal = function () {};
    const methods = {
      open: (opt) => {
        const el = document.createElement('div');

        // const app = createApp(Modal);
        // const legoModal = Vue.component('lego-modal');
        // const legoButton = Vue.component('lego-button');
        // const legoIcon = Vue.component('lego-icon');
        // const cScroll = Vue.component('cScroll');
        //
        // app.component('lego-modal', legoModal);
        // app.component('lego-button', legoButton);
        // app.component('lego-icon', legoIcon);
        // app.component('c-scroll', cScroll);
        // app.use(i18n);
        // modalInstance = app.mount(el);

        if (opt) {
          modalData.type = opt.type;
          modalData.rootId = opt.rootId || 'app';
          modalData.isShowModal = true;
          modalData.title = opt.title;
          modalData.message = opt.message;
          modalData.el = this.$el;
          modalData.action = opt.action;
          modalData.cancel = opt.cancel || (() => {});
          modalData.size = opt.size;
          modalData.cancelText = opt.cancelText;
          modalData.confirmText = opt.confirmText;
        } else {
          modalData.type = '';
          modalData.rootId = 'app';
          modalData.isShowModal = true;
          modalData.el = this.$el;
        }
        document.getElementById(modalData.rootId).appendChild(el);
        vNode = createVNode({
          data: modalData,
          extends: Modal
        });
        vNode.appContext = Vue._context;
        render(vNode, el);
      },
      close: () => {
        if (vNode) {
          vNode.type.data.isShowModal = false;
          const element = document.getElementById(vNode.type.data.rootId) 
          if (element) {
            element.removeChild(vNode.el);
          }
        }
      }
    };
    Vue.config.globalProperties.$modal = methods;
  }
};
